import React from 'react';
import { useUIStore } from '@/store/uiStore';
import CreateCustomerModal from './CreateCustomerModal';
import EditCustomerModal from './EditCustomerModal';
import CustomerDetailModal from './CustomerDetailModal';

const CustomerModals: React.FC = () => {
  const { modals, closeModal, selectedCustomer } = useUIStore();

  return (
    <>
      <CreateCustomerModal />
      <EditCustomerModal />

      <CustomerDetailModal
        isOpen={modals.customerDetail || false}
        onClose={() => closeModal('customerDetail')}
        customerId={selectedCustomer}
      />
    </>
  );
};

export default CustomerModals; 